import { Box, Chip } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';

const editsCountMessage = defineMessage({
  id: 'compose.listCard.editsCount',
  defaultMessage: '{count, plural, one {# edit} other {# edits}}',
});

/**
 * Edits count chip for composition list cards; parent footer lays out meta (flex:1)
 * and this chip so the chip stays on the first row while meta wraps.
 */
export function CompositionCardEditsCount({ count }: { count: number }) {
  const { formatMessage: $t } = useIntl();

  return (
    <Box sx={{ flexShrink: 0, display: 'flex', alignItems: 'center' }}>
      <Chip size="small" label={$t(editsCountMessage, { count })} />
    </Box>
  );
}
